import React from "react";

export const About = (props) => {
  return (
    <div id="apropos">
      <div className="container">
        <h2>A Propos</h2>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.png" className="img-responsive" alt="Simulateur" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <p>
                Choisissez la réussite, choisissez notre auto-école !<br/>
                <br/>
                Envie de décrocher votre permis rapidement et en toute confiance ? Notre auto-école vous accompagne à chaque étape avec des formateurs expérimentés, pédagogues et à l’écoute. Ici, chaque élève est unique et bénéficie d’un suivi personnalisé pour progresser à son rythme.<br/>
                <br/>
                Nous mettons à votre disposition des véhicules récents, des horaires flexibles et des méthodes d’apprentissage modernes, aussi bien pour le code que pour la conduite. Notre objectif : vous offrir une formation efficace, agréable et orientée vers la réussite à l’examen.<br/>
                <br/>
                Avec un excellent taux de réussite, une ambiance conviviale et une équipe motivée, nous transformons l’apprentissage de la conduite en une expérience positive et rassurante.<br/>
                <br/>
                Votre permis, notre priorité. Rejoignez-nous et prenez la route vers votre liberté ! 🚦🚘
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
